import { IDropdownOption, IColumn } from "@fluentui/react";
import { ToastOptions, UpdateOptions } from "react-toastify";

import pps from "./assets/pps.png";
import hda from "./assets/hda.png";
import aas from "./assets/aas.jpg";
import ipa from "./assets/ipa.png";
import tam from "./assets/tam.png";
import mic from "./assets/mic.png";
import cmp from "./assets/cmp.png";
import vid from "./assets/vid.png";
import prd from "./assets/prd.png";
import dpa from "./assets/dpa.png";
import cca from "./assets/cca.png";
import anya from "./assets/anya.png";

import pps_sml from "./assets/Assistants_Headers_Small/pps_sml.png";
import hda_sml from "./assets/Assistants_Headers_Small/hda_sml.png";
import aas_sml from "./assets/Assistants_Headers_Small/aas_sml.png";
import ipa_sml from "./assets/Assistants_Headers_Small/ipa_sml.png";
import tam_sml from "./assets/Assistants_Headers_Small/tam_sml.png";
import mic_sml from "./assets/Assistants_Headers_Small/mic_sml.png";
import cmp_sml from "./assets/Assistants_Headers_Small/cmp_sml.png";
import vid_sml from "./assets/Assistants_Headers_Small/vid_sml.png";
import prd_sml from "./assets/Assistants_Headers_Small/prd_sml.png";
import dpa_sml from "./assets/Assistants_Headers_Small/dpa_sml.png";
import cca_sml from "./assets/Assistants_Headers_Small/cca_sml.png";
import anya_sml from "./assets/Assistants_Headers_Small/anya_sml.png";

export const principleName = "X-MS-CLIENT-PRINCIPAL-NAME";

export const principleId = "X-MS-CLIENT-PRINCIPAL-ID"

export const resizerBarsWidth = 5;

// store document width to local storage. format: kgnf_rw_<group_id>
export const localStorageRescaleWidthPrepend = "kgnf_rw_"

// item cache to browser db prepend. format: kgnf_chs_<group_id>
export const itemCachePrepend = "kgnf_chs_"

//prepend for browser db cache of space modified date
export const spaceModPrepend = "kgnf_spm_"

// legacy config local storage key
export const localStorageConfigObjKey = "configObj6"

// main cards sorting property local storage key
export const localStorageSpaceSortingProp = "spaceSortingProperty"

// main cards sorting property local storage key
export const localStorageSpaceFilterProp = "spaceAssistantTypeFilter"

// main cards sorting property local storage key
export const localStorageManualOrderProp = "spaceManualOrder"

// main cards sorting property local storage key
export const localStorageHiddenGroupsProp = "hiddenGroups"

// advanced settings local storage key
export const localStorageUserSettingsKey = "kgnfUsrV1"

// details list scroll position local storage key
export const localStorageMainListScrollPosVertical = "kgnfMainScrollVert"

// details list horizontal scroll position local storage key
export const localStorageMainListScrollPosHorizontal = "kgnfMainScrollHorz"

// details list sorting local storage key
export const localStorageMainListSorting = "detailsListSorting"

// cards hidden groups local storage key
export const localStorageHiddenGroupsKey = "hiddenGroups"

// inv table column order local storage key
export const invColOrderKey = "involord_activechrtidx"

// prepend for localStorage key for expanded state of sections in invoice item table
export const scenExpandPrepend = "kgnfScanXpSt_"

// auth uri local storage key
export const localStorageAuthUriKey = "msalAuth4"

// auth tok local storage key
export const localStorageAuthTokKey = "msalAuth4Tok"

// factory tok local storage key
export const localStorageFactoryTokKey = "msal.token"

// is iframe local storage key
export const localStorageIsFrameKey = "isFrmI"

// prepend for localStorage key for hidden columns in inv item table
export const localStorageInvItemTableColumnsKeyPrepend = "kgnf_inv_cols_"

// prepend for localStorage key for hidden columns in reco matches table
export const localStorageRecoMatchesTableColumnsKeyPrepend = "kgnf_reco_cols_"

// prepend for localStorage key for column order in reco matches table
export const localStorageRecoMatchesTableColumnOrderKeyPrepend = "kgnf_reco_colorder_"

// file order local storage key
export const xplrrContentListFileOrderKey = "xprrContentListFileOrder1"

// task ids local storage key (legacy)
export const localStorageTaskIdsKey = "taskIds"

// inv main fields collapsed states
export const localStorageInvCollapsebleKey = "invMainSectionCollapseState"

// fallback pdf page aspect ratio for scaling
export const A4_ASPECT_RATIO = 297 / 210;

// date string to use for flooring dates in queries, to avoid timezone issues and very old dates
export const FLOOR_DATE_STRING = "Wed, 01 Jan 2020 00:00:00 GMT";

// empty base64 for pdf download/cache
export const emptyPdfBase64 = "data:application/pdf;base64,"

// write comment
export const speechRecogPhraseListLetters = [];




// ANCHOR[id=jsOrderItemIndexMap] order item index map
// LINK app/backend/kgnf_mdl.py#orderItemIndexMap
export const orderItemIndexMap = {
    purchase_order: 0,
    release_date: 1,
    item_quantity: 2,
    item_unit_price: 3,
    item_total_price: 4,
    item_description: 5,
    contractor_name: 6,
    contractor_vat_identification: 7,
    price_denominator: 8,
    price: 9
}




export const emptyValSrcName = "Source"

// support flow target url
export const supportFlowTarget = "https://defaulte0ffaad48863449ba8c404ff0173f1.38.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/b8ef6718aadb46b7ad31f881ae4f132a/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=cHc8XEitbHfaJyqCAw3Jfwa0tu7w4iDKJfINYKNalM8"

// item processing response
export const statusIsOkArr: string[] = [
    "success",
    "partial"
];




// write comment
export const veryShortPhrases: string[] = [
    "да",
    "не",
    "no"
];

// item processing response extended
export const statusDemandsActionArr: string[] = [
    "success",
    "partial",
    "error"
];

// after which to add divider
export const invFieldListDividerFlag: string[] = [
    "invoice_id",
    "contractor_name",
    "customer_name",
    "invoice_currency",
    "invoice_items"
];

// write comment
export const systemExtrConfigName = {
    type: "all_content",
    description: "All Content not covered by other Content Types",
    fields: [],
    auto: true
};

export const defaultContentTypeOptions: IDropdownOption[] = [
    { key: 'all_content', text: "All Content" }
]

// write comment
export const systemPostConfigName = {
    type: "all_content",
    description: "All Content not covered by other Content Types",
    fields: [],
    autofield: false
};

export const toolTipConfTexts: Record<string, string> = {
    "dontloadlastconvo": "By default, the last conversation is loaded when the assistant is opened. Switch this option to disable that behavior, so very load starts fresh.",
    "landonmanage": "Instead of landing on the Chat tab, start on the manage tab.",
    "custgreetingmessage": "Message to show when a new conversation is started. Supports markdown.",
    "showexamplequestionsonstart":"3 AI Generated Example Questions will be shown to the user when the Assistant is started",
    "usenewmodel": "Uses latest model for main chat responses if applicable.",
    "manualquestionsuggestions":"Define questions to be shown to the User when the Assistant is started. If AI Generated Questions are enabled, these will be shown before the AI Generated Questions",
    "viewerscanupload": "Enable Personal Assistant Mode and provide your coworkers with personal assistant, with unified configuration, but private content. Each user has access to only what they upload. Note: Viewers will also be allowed to upload content.",
    "hideroottabs": "No Distractions! If the assistant is going to crunch data, better not distract it from its favourite past time. Instead, options for scheduled AI reports, instant file list AI interactions, advanced API integrations and more are available.",
    "questionsuggestions": "Add followup question suggestions to the response.",
    "disablecitationhighlighting": "Disable citations and one-click document citation navigation. This setting disables core functionality of the Web App and is intended for integrated spaces or other special cases",
    "hideaisearch": "Hide list of all considered sources, on top of each response. Declutters and simplifies the response view.",
    "enabledocaudio": "Located in source content viewer as option to start narrating the text.",
    "custaiinst": "Custom instructions containing details how to respond",
    "inscope":"Allow information outside of the supplied sources to be used for responses",
    "temperature": "How creative the AI Model should be when generating responses (Higher is more creative)",
    "showchartsinuni": "Turn on necessary enhanced responses and data visualization. Content ingested without 'Per Chunk Metadata' On will have to be reingested to be available for enhanced responses and data visualization.",
    "allowvideofiles": "Upload Video Files to be added as content. Structures audio/video content into optical character recognized key frames and speech-to-text and makes them avalable to the Assistant. (Feature not always available in free/demo version)",
    "invoicesgroup": "Set this Assistant to be dedicated to Data Extraction. Used for Invoice Processing and Universal Content Extraction. This is a setting intended for integrators and requires specific assistant configuration. Incorrect configuration might lead to the assistant not working.",
    "forceocr": "Apply content structuring dedicated for images to documents that already have text. Increases ingestion time and resource usage significantly. Intended for challenging content.",
    "maxsectionlength": "Each content is split into smaller sections to be added to the Vector Index. This setting determines the legth in characters of each section (Requires Reindexing)",
    "usedocintel": "Add AI Doc Intel as option, for layout extraction. For tough cases it improves quality of final content, with better tables and complex structures handling and better layout awareness."
}

// inv which fields are  toggleble
export const invoice_togglebles: string[] = [
    "item_measure",
    "unit_price",
    "item_type",
    "item_code",
    "quantity"
];

// tbi specific contract extraction keys
export const dpaAnalysisOpt2Keys: string[] = [
    "contract_signin_date",
    "notice_or_termination_period",
    "tenor",
    "gdpr_clauses",
    "description"
];

// invoice main table (on left of invoice) - which fields will have citation button on top right
export const invoice_item_fields_with_citation_link: string[] = [
    "item_barcode",
    "item_client_code",
    "item_code",
    "description",
    "unit_price",
    "total_price"
];

// inv field names where citation links are enabled
export const invMainFieldsWCitationLink: string[] = [
    "contractor_name",
    "contractor_vat_identification",
    "iban",
    "customer_name",
    "customer_vat_identification",
    "purchase_order",
    "invoice_id",
    "invoice_total",
    "invoice_total_net",
    "vat"
];

// help mail tooltip
export const helpMailTooltip: string = "Mail us if you have any questions, need assistance or want to share feedback.";

// default ai prompt
export const defaultPromptTemplateAsInPythonBackend: string = `You are an assistant that provides analysis and information. You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place. When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly. If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`;

// no content msg div
export const noContentNoAccessGreetingContent: string = `<div class="greetingPretext"></div>`;

// tooltip configs dpa auto
export const tooltxt_toggle_dpa_extr_auto: string = "Auto-determine the base extraction of page-by-page data from the document. The results are then available for high level tasks.";

// tooltip configs dpa visualai
export const tooltxt_toggle_dpa_visualai: string = "Force vision AI over all content (even when digital text is present). Increases ingestion time and resource usage significantly. Intended for challenging content and edge cases.";

// tooltip configs high ai
export const tooltxt_toggle_dpa_highai: string = "Use high intelligence ai for post processing tasks. Increases processing resource usage.";

// tooltip configs high ai
export const tooltxt_dropdown_language: string = "Hardcode the language used for content extraction.";

// cco - chosen campaign per space with space denoted as prepend
export const campaignUserSelectPerSpace = "kgnf_camp_select_"




export const dpaExtTypeSansSingleTypeCustom = ["1","2","4", 1, 2, 4]

// msg limit text
export const msgLmtHit: string = "Space Messages Exhausted for the day. Please Consider Upgrading to Premium";

// generic replacement type
export type greplacement = {
    text: string;
    replacement: string;
};

// field interface
export interface finField {
    id: string;
    name: string;
    level: "main" | "item";
    description?: string;
    default?: boolean;
    systemDisabled: boolean;
}

// field list
export const finFieldList: finField[] = [
    // Main Fields
    {
        id: "invoice_id",
        name: "Invoice ID",
        level: "main",
        description: "The ID of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "invoice_date",
        name: "Invoice Date",
        level: "main",
        description: "The Date of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "payment_due_date",
        name: "Payment Due Date",
        level: "main",
        description: "The Payment Due Date of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "purchase_order",
        name: "Purchase Order",
        level: "main",
        description: "The Purchase Order number",
        default: true,
        systemDisabled: false
    },
    {
        id: "contractor_name",
        name: "Contractor Name",
        level: "main",
        description: "The name of the Contractor/Supplier/Seller",
        default: true,
        systemDisabled: true
    },
    {
        id: "contractor_vat_identification",
        name: "Contractor VAT Identification",
        level: "main",
        description: "The VAT Idenitification of the Contractor/Supplier/Seller",
        default: true,
        systemDisabled: true
    },
    { id: "iban",
        name: "IBAN",
        level: "main",
        description: "The IBAN number of the Customer/Buyer,Reciever",
        default: true,
        systemDisabled: false
    },
    {
        id: "contractor_address",
        name: "Contractor Address",
        level: "main",
        description: "The address of the Contractor/Supplier/Seller",
        default: true,
        systemDisabled: true
    },
    {
        id: "customer_name",
        name: "Customer Name",
        level: "main",
        description: "The name of the Customer/Buyer,Reciever",
        default: true,
        systemDisabled: true
    },
    {
        id: "customer_vat_identification",
        name: "Customer VAT Identification",
        level: "main",
        description: "The VAT Idenitification of the Customer/Buyer/Reciever",
        default: true,
        systemDisabled: true
    },
    {
        id: "customer_address",
        name: "Customer Address",
        level: "main",
        description: "The address of the Customer/Buyer,Reciever",
        default: true,
        systemDisabled: true
    },
    {
        id: "invoice_currency",
        name: "Invoice Currency",
        level: "main",
        description: "The Currency of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "vat",
        name: "VAT",
        level: "main",
        description: "The VAT Total amount of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "invoice_total_net",
        name: "Invoice Net Total ",
        level: "main",
        description: "The NET Total of the invoice.",
        default: true,
        systemDisabled: true
    },
    {
        id: "invoice_total",
        name: "Invoice Grand Total",
        level: "main",
        description: "The Grand Total amount of the Invoice",
        default: true,
        systemDisabled: true
    },

    {
        id: "invoice_items",
        name: "Invoice Items",
        level: "main",
        description: "The Items of the Invoice",
        default: true,
        systemDisabled: true
    },
    {
        id: "page",
        name: "Page",
        level: "main",
        description: "Page count and other pages related info (System Field)",
        default: true,
        systemDisabled: true
    },
    // Item-Level Fields
    {
        id: "description",
        name: "Description",
        level: "item",
        description: "The Description of the Item",
        default: true,
        systemDisabled: false
    },
    {
        id: "quantity",
        name: "Quantity",
        level: "item",
        description: "The Quantity of the Item",
        default: true,
        systemDisabled: true
    },
    {
        id: "unit_price",
        name: "Unit Price",
        level: "item",
        description: "The Unit Price of the Item",
        default: true,
        systemDisabled: true
    },
    {
        id: "discount",
        name: "Discount",
        level: "item",
        description: "Discounts, subcharges, markups. Possible to be negative",
        default: true,
        systemDisabled: true
    },
    {
        id: "discount_is_perc",
        name: "Discount Is Percentage",
        level: "item",
        description: "Indicates if the discount is in percentges",
        default: true,
        systemDisabled: true
    },
    {
        id: "total_price",
        name: "Total Price",
        level: "item",
        description: "The Total Price of the Item",
        default: true,
        systemDisabled: true
    },
    {
        id: "item_number",
        name: "Item Number",
        level: "item",
        description: "The Sequential Number of the Item",
        default: true,
        systemDisabled: true
    },
    {
        id: "item_code",
        name: "Item Code",
        level: "item",
        description: "The Code of the Item",
        default: true,
        systemDisabled: false
    },
    {
        id: "item_measure",
        name: "Item Measure",
        level: "item",
        description: "The Measure of the Item",
        default: true,
        systemDisabled: false
    },
    {
        id: "item_type",
        name: "Item Type",
        level: "item",
        description: "The Type of the Item",
        default: true,
        systemDisabled: false
    },
    {
        id: "item_barcode",
        name: "Item Barcode",
        level: "item",
        description: "The Barcode of the Item",
        default: true,
        systemDisabled: false
    },
    {
        id: "item_client_code",
        name: "Item Client Code",
        level: "item",
        description: "Client Code of the Item",
        default: true,
        systemDisabled: false
    }
];

// map assistant keys
export type ImgMapKeys = "pps" | "hda" | "aas" | "ipa" | "tam" | "mic" | "cmp" | "vid" | "prd" | "dpa" | "cca" | "";

export type columnTableSelectorSrc = 'invoice_items' | 'reco_matches';



// assistant codes
export const assistantCodes = Object.freeze({
    pps: "pps",
    hda: "hda",
    aas: "aas",
    ipa: "ipa",
    tam: "tam",
    anya: "anya",
    mic: "mic",
    cmp: "cmp",
    vid: "vid",
    prd: "prd",
    dpa: "dpa",
    cca: "cca",
    "": "Multi-Purpose Assistant"
});

// assistant default image map
export const imgMap = Object.freeze({
    pps: pps,
    hda: hda,
    aas: aas,
    ipa: ipa,
    tam: tam,
    mic: mic,
    cmp: cmp,
    vid: vid,
    prd: prd,
    dpa: dpa,
    cca: cca,
    anya: anya,
    "": anya
});

// assistant small image map
export const imgMapSml = Object.freeze({
    pps: pps_sml,
    hda: hda_sml,
    aas: aas_sml,
    ipa: ipa_sml,
    tam: tam_sml,
    mic: mic_sml,
    cmp: cmp_sml,
    vid: vid_sml,
    prd: prd_sml,
    dpa: dpa_sml,
    cca: cca_sml,
    anya: anya_sml,
    "": anya_sml
});

// assistant display name map
export const nmeMap = Object.freeze({
    pps: "Company Docs",
    hda: "IT Helpdesk",
    aas: "Automation API",
    ipa: "Invoice Handling",
    tam: "Advanced Docs",
    anya: "Multi-Purpose",
    mic: "Meeting Listener",
    cmp: "Content Differences",
    vid: "Video Content",
    prd: "Product Docs",
    dpa: "Universal Content",
    cca: "Call Center",
    "": "Multi-Purpose"
});



export const assistTypeOpt: Record<string, string> = Object.freeze({
    dpa: "Universal Content Assistant",
    cca: "Call Center Operator"
});

// app page codes
export const locationCodes: Record<string, string> = Object.freeze({
    grp: "grp",
    lib: "lib",
    chat: "chat",
    xplr: "xplr",
    acc: "acc",
    adm: "adm"
});

export const keyToFileProp = Object.freeze({
    kgnf_key: "fileid",
    kgnf_name: "displayName",
    dateModifiedValue: "dateModified",
    kgnf_inv_id: "invoicedataobj.invoice_id",
    kgnf_customer: "invoicedataobj.customer_name",
    kgnf_contractor: "invoicedataobj.contractor_name",
    kgnf_vat: "invoicedataobj.vat",
    kgnf_total: "invoicedataobj.invoice_total",
    kgnf_date: "invoicedataobj.invoice_date",
    due_date: "invoicedataobj.payment_due_date",
    iban: "invoicedataobj.iban",
    contractor_vat_identification: "invoicedataobj.contractor_vat_identification",
    customer_vat_identification: "invoicedataobj.customer_vat_identification",
    approved: "invoicedataobj.approved",
    kgnf_tag: "tag",
    kgnf_fileurl: "file_url",
    kgnf_type: "doc_category",
    kgnf_status: "docstatus",
    kgnf_valid: "invoicedataobj.kgnf_valid",
});



export type locCodeType = "grp" | "lib" | "chat" | "xplr" | "acc" | "adm" | "";


// 🧪 value-filter config: columns whose distinct values can be filtered client-side.
// getValue = stable string key for grouping/matching; getLabel = checklist display.
export interface ValueFilterColConfig {
    key: string;
    getValue: (item: any) => string;
    getLabel: (raw: string) => string;
}

export const valueFilterableCols: ValueFilterColConfig[] = [
    {
        key: "approved",
        getValue: (item: any) => (item?.approved == 1 ? "1" : "0"),
        getLabel: (raw: string) => (raw === "1" ? "Confirmed" : "Not Confirmed"),
    },
];


export const noVisibilityChangeCols: string[] = [
    "kgnf_filetype",
    "kgnf_key",
    "kgnf_name",
    "analysis",
    "kgnf_type",
    "kgnf_status",
    "invoice_id",
    "approved",
    "kgnf_valid"
];

export type pdfsrccodestype = "inv" | "modal" | "sbs";

// xplrrpdf pdf viewer view type - default, invoice, side by side
export const pdfSourceCodes = Object.freeze({
    inv: "inv",
    modal: "modal",
    sbs: "sbs"
});

// empty call center convo_config ⇒ elevenlabs tts, faster rate, exact collection usecase, cca greeting, no scenarios, 1 min lookback
export const initial_convo_config = {
    "tts": 2,
    "rate": 20,
    "usecase": 1,
    "greeting": " Здравейте, благодаря, че се свързахте с нас! С какво мога да Ви помогна?",
    "scenarios": [],
    "lookback_mins": 1
}

// empty doc extraction config
export const initial_docextractionconfig = [{"name":"User_First_Name","description":"The first name of the user","type":"number","validation_source":"17091","identificator":false,"display_name":"Вашето_Име"}]

// assistant creation cards info
export const assistantCardItems = [
    {
        title: "Company Content Assistant",
        section: "Company Documents",
        description: "Provides quick, accurate and up-to-date consultations over your content to employees/customers",
        tooltip: `<div class="assistantsTooltip">
        <p><h2><span class="assistantsTooltipHeadColored">Balanced chat assistant</span> capable of handling most content.</h2></p><br/>
        <p><strong>Add your content and share the assistant with users or place a widget on your web site</strong></p>
    <ul>
        <li>▸Accurate, hallucination free, consultations over dynamic content - files/web/video/images</li>
        <li>▸One-click source review</li>
        <li>▸Permission management, anonymous access, guest access</li>
        <li>▸Balanced content processing</li>
        <li>▸Web Site Widgets</li>
        <li>▸Customization Options</li>
    </ul>
</div>`,
        imageSrc: pps,
        imageSrcSmall: pps_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
            custgreetingmessage: "Hello! I'm here to help you with any questions you have about the available content.<br><br>How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "pps",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 0,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "Tech Mentor",
        section: "Company Documents",
        description: "Capable of analysing tough content and extrapolate conclusions based on content interactions.",
        tooltip: `<div class="assistantsTooltip">
        <p><h2><span class="assistantsTooltipHeadColored">Extrapolates and draws conclusions based on complex content interactions.</span> Capable of processing tough content.</h2></p><br/>
        <p><strong>Let your team leverage this assistant for deeper insights and understanding.</strong></p>
    <ul>
        <li>▸Capable of connecting the dots between various content and extrapolating conclusions</li>
        <li>▸Beefed up Content Pre-Processing capable of dealing with tough content</li>
        <li>▸Powerful Contextual Understanding</li>
        <li>▸Specialized systems for response accuracy</li>
    </ul>
</div>`,
        imageSrc: tam,
        imageSrcSmall: tam_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
            custgreetingmessage: "Hello! I'm here to help you with any technical documentation and training.<br><br>How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "tam",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 0,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "Product Documentation Assistant",
        section: "Company Documents",
        description: "AI Search UI for Product Documentation.(Beta)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>Chat assistant <span class="assistantsTooltipHeadColored">tailored to provide Product Documentation Experience</span></h2></p><br/>
        <p><strong>Add your product documentation and share publicly or via web site widget with your users, to give them premium product support</strong></p>
    <ul>
        <li>▸Dedicated Landing page showcasing content thumbnails</li>
        <li>▸Search bar positioned on top of screen</li>
        <li>▸One click access to exact document paragraph in question</li>
    </ul>
</div>`,
        imageSrc: prd,
        imageSrcSmall: prd_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: "You are an assistant that answers questions and provides information about products and documentation.",
            custgreetingmessage: "Hello! Please ask you question?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "prd",
            showexamplequestionsonstart: 1,
            usedocintel: 0,
            forceocr: 0,
            allowvideofiles: 0,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "IT Helpdesk Assistant",
        section: "Conversational",
        disabled: true,
        description: "Optimized for IT Support, FAQs. Provides solutions and sources increasing first call resolution. (Integration options comming soon)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>What's Unique with <span class="assistantsTooltipHeadColored">IT Helpdesk Assistant Assistant?</span></h2></p><br/>
        <p><strong>Integration Options:</strong></p>
    <ul>
        <li>▸Supports Integrations with SharePoint, ServiceNow, Confluence and others*</li>
        <p><strong>Tailor-Made Document Learning Pipeline:</strong></p>
        <li>▸Tailored AI Content Extraction</li>
        <li>▸Advanced Document Context Analysis</li>
        <li>▸Summary and Metadata Generation</li>
        <p><strong>User Experience:</strong></p>
        <li>▸One-Click Navigation to Source</li>
        <li>▸Highlights on most influential Source Content</li>
        <li>▸Suggested Questions after each Answer</li>
        <li>▸4-Level Permission Capabilities</li>
        <li>▸Feedback</li>
        <p><strong>Customization Options:</strong></p>
        <li>▸Suggested Questions in Greeting</li>
        <li>▸Custom Greeting Message and Header Image</li>
    </ul><br/><span>*Integration Options available for Paid Plans only</span>
</div>`,
        imageSrc: hda,
        imageSrcSmall: hda_sml,

        commingSoon: false,
        creationData: {
            custaiinst:
                "You are a Helpdesk assistant that provides solutions and sources. You are here to help employees with IT support, troubleshooting, and FAQs.",
            custgreetingmessage: "Hello! I'm here to help you with any **support**, **troubleshooting**, and **FAQs**.<br><br>How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "hda",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 0,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "Invoice Processing",
        section: "Content Processing",
        description: "Autonomous AI invoice processing with unprecedented 99%+ success rate.",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>Autonomous AI invoice processing with <span class="assistantsTooltipHeadColored">with unprecedented 99%+ success rate.</span></h2></p><br/>
        <p><strong>Our most mature content processing offering with guaranteed accuracy and multiple industry leading advances</strong></p>
    <ul>
        <li>▸Unprecedented 99%+success rate from top level data, down to line item quantities, single unit pricing, discounts, compound units</li>
        <li>▸Fully integratable with existing systems on both ends via our API, callbacks & workflows.</li>
        <li>▸Industry leading self-assessment framework, detecting anomalies by fully reverse calculating each invoice from smallest unit to grand total</li>
        <li>▸Add your own additional instructions for each invoice field</li>
        <li>▸Configurable data reconciliation with existing systems</li>
        <li>▸Supports fully featured manual validation and approvals (but you won't need them:)</li>
    </ul>
</div>`,
        imageSrc: ipa,
        imageSrcSmall: ipa_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: " ",
            custgreetingmessage: "Hi, I'm here to help you with invoice processing and reporting.<br><br>How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 1,
            allowaudiodocentry: 0,
            assistanttype: "ipa",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 0,
            questionsuggestions: 0,
            perchunkmeta: 0,
            extractionfieldlist: {
                excl: [],
                instr: [],
                custom_props: [],
                inv_pre_agent: 1,
                props_to_show: "",
                adv_post_check: 0,
                align_rotation: 1,
                inv_do_callback: 0,
                inv_callback_url: "",
                use_latest_model: 1,
                allowed_deviation: 0,
                extended_cli_code: 0,
                use_v4_extraction: 1,
                adjust_small_diffs: 0,
                po_editing_enabled: 0,
                enable_custom_props: 1,
                full_pre_precessing: 0,
                do_inv_item_combining: 0,
                enable_expanded_extraction: 1
            }
        },
    },
    {
        title: "Universal Content Processing",
        section: "Content Processing",
        description: "Structure and Analyse Data from Content (Beta)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>Fully <span class="assistantsTooltipHeadColored">user-configurable autonomous content processing</span></h2></p><br/>
        <p><strong>Autonomous processing tailored to your needs for any business case (e.g. contracts, legal documents, customs declarations, expense reports, etc.)</strong></p>
    <ul>
        <li>▸Autonomously extracts fields and answers complex questions for incoming documents with unprecedented accuracy. All fully user-configurable.</li>
        <li>▸Highly intelligent and capable of understanding complex document logic.</li>
        <li>▸Configurable freeform content types (e.g. documents about dogs from west veterinary clinic)</li>
        <li>▸Fully integratable with any system with API, workflows and callbacks (e.g. incoming mail ⇒ structure mail and attachments ⇒ send structured data to downstream systems)</li>
    </ul>
    </div>`,
        imageSrc: dpa,
        imageSrcSmall: dpa_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
            custgreetingmessage: "Hi, I'm here to help you with document extraction and reporting.<br><br>How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 1,
            allowaudiodocentry: 0,
            assistanttype: "dpa",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 0,
            docextractionuseauto: 1,
            perchunkmeta: 0,
            showchartsinuni: 1,

        }
    },
    {
        title: "Changes Assistant (beta)",
        section: "Content Processing",
        description: "Intelligently compare and analyse differences in content. (beta)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2><span class="assistantsTooltipHeadColored">Compare logically similar documents that are technically different</span> like digital doc and scanned copy</h2></p><br/>
        <p><strong>Unique assistant offering visual comparison capabilities for documents with similar content but different format, layouts, structures or content obstructions</strong></p>
    <ul>
        <li>▸Highly specialized AI processing pipeline capable of aligning complex document structures and layouts.</li>
        <li>▸Unprecedented results with digital originals and scanned signed/stamped copies</li>
        <li>▸Unprecedented results with same content formatted for different purposes e.g. A4 document ⇔ A3 leaflet</li>
    </ul>
</div>`,
        imageSrc: cmp,
        imageSrcSmall: cmp_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
            custgreetingmessage: "Hello! I'm here to help you compare and analyse changes in documents. How can I help you today?",
            allowyoutube: 0,
            allowweb: 0,
            invoicesgroup: 0,
            allowaudiodocentry: 1,
            assistanttype: "cmp",
            showexamplequestionsonstart: 1,
            usedocintel: 1,
            forceocr: 1,
            docextractionuseauto: 0,
            questionsuggestions: 0,
            perchunkmeta: 0
        }
    },
    {
        title: "Call Center Assistant",
        section: "Audio",
        description: "Calls or Receives calls from users and provides or collects information and accomplishes tasks.",
        tooltip: `<div class="assistantsTooltip">
        <p><h2><span class="assistantsTooltipHeadColored">Human-level ai call center operator handling any voice call</span> like support, screening, promotional, consultation, status inquiries, etc.</h2></p><br/>
        <p><strong>Our most advanced AI solution for voice interactions</strong></p>
    <ul>
        <li>▸Human level conversation control</li>
        <li>▸Sub 1 second response latency</li>
        <li>▸Full support for multiple languages incuding Bulgarian</li>
        <li>▸Capable of collecting user information</li>
        <li>▸Capable of recognizing user and providing user-specific information</li>
        <li>▸Can ground collected data against external system data</li>
        <li>▸Configurable with natural text with scenarious and data fields.</li>
        <li>▸Sub 1.5 second response latency when providing data from unstructured sources like documents</li>
        <li>▸Supports SIP, Twilio, Infobip, Viber, WhatsApp, Web and others</li>   
        <li>▸Can pass call results and collected data to external Systems</li>     
        <li>▸Can perform further analysis of collected data and proceed accordingly</li>   
    </ul>
</div>`,
        imageSrc: cca,
        imageSrcSmall: cca_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are a call center agent, answering calls from people.`,
            custgreetingmessage: "Hello! Head on to the manage section to configure your Call Center Assistant.",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "cca",
            showexamplequestionsonstart: 0,
            usedocintel: 0,
            forceocr: 0,
            convomode: 1,
            convolang: "auto",
            disablecitationhighlighting: 1,
            perchunkmeta: 0,
            convo_config: initial_convo_config,
            docextractionconfig: initial_docextractionconfig,
            docextractionuseauto: 0
        }
    },
    {
        title: "Interview Assistant (beta)",
        description: "Records and transcribes interviews. Analyses and provides tools to extract insights from interviews. (beta)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>Records and transcribes conversations and provides <span class="assistantsTooltipHeadColored">consultations and analysis over large volumes of audio conversation data</span></h2></p><br/>
        <p><strong>Record Interviews or other conversations and let the assistant help you extract insights</strong></p>
    <ul>
        <li>▸Transcribes Real-time Conversations</li>
        <li>▸Supports Speaker Diarization</li>
        <li>▸Supports Real-time Edits to Content</li>
        <li>▸Learns from the conversations</li>
    </ul>
</div>`,
        imageSrc: mic,
        section: "Audio",
        imageSrcSmall: mic_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are a professional Interview Assistant, helping interviewers et insights over their interviews. You are able to record and transcribe interviews, analyse them and provide insights.`,
            custgreetingmessage: "Hello! I'm here to help you get the most out of your interview data. How can I help you today?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 0,
            allowaudiodocentry: 1,
            assistanttype: "mic",
            showexamplequestionsonstart: 1,
            usedocintel: 0,
            forceocr: 0,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "Video Assistant (beta)",
        section: "Video",
        description: "Upload and consult with Video Content. Convert Video to Presentations. (beta)",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>Processes and <span class="assistantsTooltipHeadColored">consults over video files / youtube</span></h2></p><br/>
        <p><strong>Learns over Video Content (Uploaded Video Files or Youtube)</strong></p>
    <ul>
        <li>▸Highly capable ai processing of video preserving key frames, frame text and audio speech</li>
        <li>▸Processes the content for insights and analysis</li>
        <li>▸Provides consultations over large volumes of video content</li>
        <li>▸One-click access to frame that influenced the ai answer with audio subtitles and link to actual video timestamp</li>
    </ul>
</div>`,
        imageSrc: vid,
        imageSrcSmall: vid_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
            custgreetingmessage: "Hello! I'm here to help you learn from videos?",
            allowyoutube: 0,
            allowweb: 0,
            invoicesgroup: 0,
            allowaudiodocentry: 0,
            assistanttype: "vid",
            showexamplequestionsonstart: 1,
            usedocintel: 0,
            forceocr: 0,
            allowvideofiles: 1,
            questionsuggestions: 1,
            perchunkmeta: 1
        }
    },
    {
        title: "Automation API Agent",
        section: "Integrators",
        description: "Primed for Business Process Automation, RPA and API integrations.",
        tooltip: `<div class="assistantsTooltip">
        <p><h2>What's Unique with <span class="assistantsTooltipHeadColored">Automation API Agent?</span></h2></p><br/>
        <p><strong>Offers API Access and a blank slate to customize the Platform as needed for Automation Projects</strong></p>
</div>`,
        imageSrc: aas,
        imageSrcSmall: aas_sml,
        disabled: false,
        commingSoon: false,
        creationData: {
            custaiinst: " ",
            custgreetingmessage: "Hi, this is an AI Automation API Agent.<br><br>What can I do for you?",
            allowyoutube: 0,
            allowweb: 1,
            invoicesgroup: 1,
            allowaudiodocentry: 0,
            assistanttype: "aas",
            showexamplequestionsonstart: 1,
            usedocintel: 0,
            forceocr: 0,
            perchunkmeta: 0
        }
    }
];

// multi purpose assistant creation info
export const multiPurposeAssistantCreationData = {
    custaiinst: `You are an assistant that provides analysis and information.
You are encouraged to reason, infer, and calculate based on the data, charts, formulas, and technical content found in the documents — even if the full answer is not explicitly stated in one place.
When applicable, synthesize information from multiple sources, apply known engineering formulas, and explain your reasoning clearly.
If the required data is missing or insufficient for a reliable answer, state this transparently and provide any helpful context or guidance based on available information.`,
    custgreetingmessage: "Hello! I'm here to help you with any questions that you might have. How can I help you today?",
    allowyoutube: 0,
    allowweb: 1,
    invoicesgroup: 0,
    allowaudiodocentry: 0,
    assistanttype: "",
    showexamplequestionsonstart: 1,
    usedocintel: 1,
    forceocr: 0,
    allowvideofiles: 1,
    questionsuggestions: 1,
    perchunkmeta: 1
};


export const ipaDocTypes = [
    "invoice",
    "credit_note",
    "debit_note",
    "purchase_order",
    "statement",
    "receipt",
    "delivery_note",
    "quote",
    "form",
    "document"
]



// item types
export const detailsListContentTypeOptions = [
    { key: "document", text: "document" },
    { key: "invoice", text: "invoice" },
    { key: "credit_note", text: "credit note" },
    { key: "debit_note", text: "debit note" },
    { key: "receipt", text: "receipt" },
    { key: "contract", text: "contract" },
    { key: "form", text: "form" },
    { key: "policy", text: "policy" },
    { key: "offer", text: "offer" },
    { key: "article", text: "article" },
    { key: "email", text: "email" },
    { key: "report", text: "report" },
    { key: "guide", text: "guide" },
    { key: "book", text: "book" },
    { key: "memo", text: "memo" },
    { key: "note", text: "note" },
    { key: "data", text: "data" },
    { key: "other", text: "other" }
];

// default greeting message
export const defaultGreetingsMessage: string = `<div class="answerText">Hey,</div>
<div class="answerText">I'm <b>Kognify </b> and I'm here to help you understand and get insights from your content.</div>
<div class="answerText">You can chat with me or you can check the Documents that I know about in the Manage Section</div>
<div class="answerCardContainer">
</answerSuggestions>
</div>`;

export const get_typed_greeting_message = (assistantType: string) => {
    const assistantName = nmeMap[assistantType as ImgMapKeys] || "Multi-Purpose";
    return assistantType == assistantCodes.cca ? `
    <div class="answerCardContainer">
        <div class="answerCard" onclick="window.greetingMessageStartCall()">
            <div class="greetingItemTitle" style="font-size: 24px; color: ">Start Call</div>
            <div class="topGreetingText">Start a call with the assistant</div>
        </div>
        <div class="answerCard" onclick="window.greetingMessageViewDocs('')">
            <div class="greetingItemTitle" style="font-size: 24px; color: ">Navigate to Management Tab</div>
            <div class="topGreetingText">Check the assistant content and call center configuration</div>
        </div>  
    </div> 
    ` : `
    <div class="greetingPretext">It looks like there is no content for this Assistant and you have permissions to add content. Head on to the Content Section</div>
    <div class="answerCard" onclick="window.greetingMessageViewDocs('')">
        <div class="greetingItemTitle" style="font-size: 24px; color: ">Navigate to Management Tab</div>
        <div class="topGreetingText">View content available to this assistant. Add Content to get started.</div>
    </div>
    `;
}

// no content default greeting
export const defaultGreetingContent: string = `
<div class="greetingPretext">It looks like there is no content for this Assistant and you have permissions to add content. Head on to the Content Section</div>
<div class="answerCard" onclick="window.greetingMessageViewDocs('')">
    <div class="greetingItemTitle" style="font-size: 24px; color: ">View Content List</div>
    <div class="topGreetingText">View what documents are available to this Assistant. Add Content to get started.</div>
</div>
`;

// assistant answer card html
export const answerCardHTML: string = `
<div class="answerCard" onclick="window.greetingMessageBeginConversation('{kgnf_replace}');">
    <div class="topGreetingText">Suggested Question</div>
    <hr class="hrzntlLn">
    <i class="fas fa-lightbulb" style="font-size: 24px; color: #ffc107;"></i>
    <h3 class="greetingItemTitle">{kgnf_replace}</h3>
</div>
`;

// pb replacement
export const pb_replace: greplacement[] = [
    { text: "CSoft", replacement: "Сисофт" },
    { text: "ТРЗ", replacement: "Тъ.Ръ.Зъ. " },
    { text: "Т Р З ", replacement: "Тъ.Ръ.Зъ. " },
    { text: "@", replacement: " " },
    { text: " ат ", replacement: "  " }
];


// tbi specific field config
export const dpaAnalysisOpt2KeysMap: { [key: string]: string } = {
    notice_or_termination_period: "Notice or Termination Period",
    tenor: "Tenor",
    gdpr_clauses: "GDPR Clauses",
    contract_signin_date: "Contract Sign-in Date"
};

// default settings string
export const dfltSettingsLocalStr: string = `{
    "promptTemplate": "Assistant helps find answers to questions about information in the available documents. If there isn't enough information below, ask for more specific information.",
    "retrieveCount": 5,
    "retrievalMode": "hybrid",
    "useSemanticRanker": true,
    "shouldStream": true,
    "useSemanticCaptions": false,
    "searchOnly": false,
    "useHighlightsAsSource": false,
    "useSuggestFollowupQuestions": true,
    "isDark": false,
    "experimentalFeatures": false,
    "showDocLibInChatTab": false,
    "sourceHighlighting":false
}`;

// assistant creation cards info
export const chatbotScript = (companyid: string, selectionId: string, selectionText: string, anon: boolean, shouldBeSearchBox: boolean) => {
    const scrsrc = shouldBeSearchBox ? "https://kgnf.blob.core.windows.net/msc/kgnfyV0_24.js" : "https://kgnf.blob.core.windows.net/msc/kgnfyV0_23.js";
    const ifrmtype = shouldBeSearchBox ? 2 : 1;
    const url =
        anon == true
            ? `${window.location.origin}?redeemCode=${encodeURIComponent(selectionId)}&spt=${encodeURIComponent(selectionText)}&ifrm=${ifrmtype}&A=1`
            : `${window.location.origin}?redeemCode=${encodeURIComponent(selectionId)}&spt=${encodeURIComponent(selectionText)}&ifrm=${ifrmtype}`;

    return `<script src="${scrsrc}"></script>
<script>
    initChatbot({
        chatBotID: "${url}",
        iconSrc: "https://kgnf.blob.core.windows.net/imgs/kgnf_logo_only.svg",
        width: 600,
        height: 800,
        userid:""
    });
</script>`;
};

// multi purpose assistant creation info
export const chatbotEmbed = (companyid: string, selectionId: string, selectionText: string, anon: boolean) => {
    const url =
        anon == true
            ? `${window.location.origin}/#/${companyid}/${encodeURIComponent(selectionId)}/chat?ifrm=1`
            : `${window.location.origin}?redeemCode=${encodeURIComponent(selectionId)}&spt=${encodeURIComponent(selectionText)}&ifrm=1&A=1`;

    return `<iframe
    src="${url}"
    style="width: 800px; height: 800px; border: none; z-index: 1000;"allowtransparency="true">
</iframe>`;
};

// cca convo syllabic stress words - az speech fixes
export const convoSyllabicStressWords: { [key: string]: string } = {
    "предостав[е]те": "prɛdostɐvɛˈte",
    "дал[и]": "daliˈ",
    "дос[е]га": "dɔsɛɡaˈ",
    "обраб[о]тим": "ɔbrɐbɔˈtim",
    "п[о]-б[ъ]рзо": "po-bɤˈrzo",
    "к[а]жете": "kaˈʒɛte",
    "нив[а]": "nivaˈ",
    "отв[о]реност": "ɔtvɔˈrɛnost",
    "п[о]-м[а]лко": "po-mɐˈlko",
    "изгов[о]рите": "izɡɔvɔˈrite",
    "произнес[е]те": "prɔiznɛseˈte",
    "разб[и]ра:": "razbiˈra",
    "идентифик[а]тор": "identifikaˈtor",
    "изгов[a]ряйки": "izɡɔvɐˈrjajki",
    "д[о]бър ден": "dɔˈbɤr dɛn",
    "кaж[е]те": "kˈaʒˈɛtˈe",
    "дa повторите": "da povtˈorɪte",
    "дa го": "da ɡо",
    "п[о]стбанк": "postbɐŋk"
};

// cca convo syllabic stress words - az speech fixes
export const CONVO_SYLLABIC_STRESS_WORDS: { [key: string]: string } = {
    "предостав[е]те": "prɛdostɐvɛˈte",
    "дал[и]": "daliˈ",
    "дос[е]га": "dɔsɛgaˈ",
    "обраб[о]тим": "ɔbrɐbɔˈtim",
    "п[о]-б[ъ]рзо": "po-bɤˈrzo",
    "нив[а]": "nivaˈ",
    "отв[о]реност": "ɔtvɔˈrɛnost",
    "п[о]-м[а]лко": "po-mɐˈlko",
    "изгов[о]рите": "izɡɔvɔˈrite",
    "произнес[e]те": "prɔiznɛseˈte",
    "разб[и]рa:": "razbiˈra",
    "идентифик[a]тор": "identifikaˈtor",
    "изгов[a]ряйки": "izɡɔvɐˈrjajki",
    "д[о]бър ден": "dɔˈbɤr dɛn",
    "го к[a]жете": "go kaˈʒɛte",
    "кажете го": "kaʒɛˈte go",
    "дa го": "da go",
    "дa повторите": "da povtˈorɪte",
    "п[о]стбанк": "postbɐŋk",
    автопарк: "aˈvtopaˈɾk",
    "б[у]квa": "bˈukva",
    буква: "bˈukva",
    "моля кажете": "mˈolʲa kaʒɛˈte",
    регистрационният: "rɛɡistratsiɒˈnijət",
    обявете: "obʲavˈɛtɛ",
    "да обявите": "da obʲavˈitɛ",
    акаунт: "akaˈunt",
    "кажете ми": "kaʒɛˈte mi",
    потвърден: "pɔtvɐrˈdɛn"
};

// language dropdown codes
export const transcriptLanguageOptions: IDropdownOption[] = [
    { key: "en-US", text: "English" },
    { key: "bg-BG", text: "Bulgarian" }
];

// search results dropdown options
export const resultCountOptions: IDropdownOption[] = [
    { key: "3", text: "3 results" },
    { key: "5", text: "5 results" },
    { key: "10", text: "10 results" },
    { key: "20", text: "20 results" }
];

// convo lang options
export const convoLangOptions: IDropdownOption[] = [
    { key: "auto", text: "auto" },
    { key: "en-US", text: "english" },
    { key: "bg-BG", text: "bulgarian" }
];

// convo lang options for wav uploads
export const convoLangWavOptions: IDropdownOption[] = [
    { key: "auto", text: "auto" },
    { key: "en-US", text: "english" },
    { key: "bg-BG", text: "bulgarian" },
    { key: "de-CH", text: "swiss german" }
];


// cca convo lang for cca
export const convoLangOptionsCCA: IDropdownOption[] = [
    { key: "en-US", text: "english" },
    { key: "bg-BG", text: "bulgarian" },
    { key: "ru-RU", text: "russian" },
    { key: "auto", text: "auto", disabled: true }
];

// cca convo purpose dropdown
export const convoPurposeOptionsCCA: IDropdownOption[] = [
    { key: 1, text: "Collect Highly Specific Data" },
    { key: 2, text: "Collect General Data" }
];

// cca convo lookback minutes dropdown
export const convoLookbackMinutesCCA: IDropdownOption[] = [
    { key: 0, text: "0 minutes" },
    { key: 1, text: "1 minute" },
    { key: 3, text: "3 minutes" },
    { key: 5, text: "5 minutes" },
    { key: 10, text: "10 minutes" },
    { key: 15, text: "15 minutes" },
    { key: 30, text: "30 minutes" },
    { key: 60, text: "1 hour" },
    { key: 120, text: "2 hours" },
    { key: 240, text: "4 hours" },
    { key: 480, text: "8 hours" },
    { key: 720, text: "12 hours" },
    { key: 1440, text: "1 day" }
];

// cca convo speech options
export const convoTTSOptionsCCA: IDropdownOption[] = [
    { key: 2, text: "Female 1" },
    { key: 3, text: "Female 2" },
    { key: 4, text: "Female 3" }
];

// elevenlabs voice id mapping (mirrors backend VOICE_ELEVEN_CODE_TO_ID_MAP in kgnf_mdl.py)
export const VOICE_ELEVEN_CODE_TO_ID_MAP: Record<number, string> = {
    2: 'cgSgspJ2msm6clMCkdW9',
    3: 'jqcCZkN6Knx8BJ5TBdYR',
    4: 'OYTbf65OHHFELVut7v2H',
    5: 'V0cljQmo7wpx8LTdbqfJ'
};

//ANCHOR[id=dpa_analysis_options] dpa analysis options
export const dpaAnalysisOptions: IDropdownOption[] = [
    { key: 1, text: "Don't Run" }, // No DPA definition to run
    { key: 2, text: "Predef 01" }, // TBI custom predefined option
    { key: 3, text: "Custom" }, // 1-content type config option
    { key: 4, text: "Multi-Type" } // multi-type content processing option
];

// dpa analysis options display names
export const dpaAnalysisOptionsDisplayNames: Map<String, string> = new Map([
    ["1", "Don't Run"],
    ["2", "Predef 01"],
    ["3", "Custom"],
    ["4", "Multi-Type"]
]);




export const remapLicanceCodeToName: { [key: string]: string } = {
    "ipa": "Autonomous Accounting",
    "1": "Business Licensing",
    "dpa": "Universal Content Processing",
    "medical_leave_notes": "Medical Leave Notes",
};

// cca convo speech speed options
export const convoRateOptionsCCA: IDropdownOption[] = [
    { key: 10, text: "+10%" },
    { key: 20, text: "+20%" },
    { key: 30, text: "+30%" },
    { key: 40, text: "+40%" }
];

// general questions language options
export const genQuestionsLangOptions: IDropdownOption[] = [
    { key: "auto", text: "Auto Detect" },
    { key: "English", text: "English" },
    { key: "Bulgarian", text: "Bulgarian" },
    { key: "Spanish", text: "Spanish" },
    { key: "French", text: "French" },
    { key: "German", text: "German" },
    { key: "Italian", text: "Italian" },
    { key: "Portuguese", text: "Portuguese" },
    { key: "Russian", text: "Russian" },
    { key: "Chinese", text: "Chinese" },
    { key: "Japanese", text: "Japanese" },
    { key: "Korean", text: "Korean" },
    { key: "Hindi", text: "Hindi" },
    { key: "Arabic", text: "Arabic" },
    { key: "Dutch", text: "Dutch" },
    { key: "Swedish", text: "Swedish" },
    { key: "Turkish", text: "Turkish" },
    { key: "Polish", text: "Polish" }
];

// extraction field type options
export const extrTypeOptions: IDropdownOption[] = [
    { key: "string", text: "Text" },
    { key: "number", text: "Number" },
    { key: "boolean", text: "Yes/No" },
    { key: "array", text: "List" },
    { key: "object", text: "Object" }
];

// extraction field type options reduced
export const extrTypeOptionsReduced: IDropdownOption[] = [
    { key: "string", text: "Text" },
    { key: "number", text: "Number" },
    { key: "boolean", text: "Yes/No" }
];

// extraction task types
export const extrTaskTypes: IDropdownOption[] = [
    { key: "Answer", text: "Answer" },
    { key: "Sumarize", text: "Sumarize" },
    { key: "Web", text: "Web Hook" }
];

// extraction content filter
export const extrContentFilter: IDropdownOption[] = [
    { key: "Tags", text: "Tags" },
    { key: "Type", text: "Type" },
    { key: "Filter", text: "Filter" }
];

// extraction filter tags (legacy)
export const extrTags: IDropdownOption[] = [
    { key: "Today", text: "Today" },
    { key: "3Days", text: "3 Days" },
    { key: "This Week", text: "This Week" },
    { key: "This Month", text: "This Month" }
];

// lic options
export const compTierOptions: IDropdownOption[] = [
    { key: "0", text: "Credit Card Licensing" },
    { key: "1", text: "Business Licensing" }
];

// sorting options for assistant cards
export const sortingOptions: IDropdownOption[] = [
    { key: "oid", text: "Newest" },
    { key: "dailymsgs", text: "Most Active" },
    { key: "filecount", text: "Most Content" },
    { key: "manual", text: "Manual Order" }
];

// filter options for assistant cards
export const filterOptions: IDropdownOption[] = [
    { key: "all", text: "All" },
    { key: "mine", text: "Owned" },
    { key: "hidden", text: "Hidden" }
];

// dpa content types
export const extrTypeTooltipTexts = {
    AddContentType: `
<div class="assistantsTooltip">
        <p><h3 style="color:#00c6af">Create New Content Type</h3></p><br/>
        <p><strong>Content Types allow you to describe different content to the assistant, and specify how it should be processed</strong></p>
    <ul>
        <li>▸Describe specific content, based on its content</li>
        <li>▸Configure tasks the assistant should do when it encounters such a document</li>
    <ul>    
    </div>
`,
    EditContentType: `
<div class="assistantsTooltip">
        <p><h3 style="color:#2a8091">Edit the current Content Type</h3></p><br/>
        <p><strong>Edit the Name</strong></p>
        <p><strong>Edit the Instructions for AI on how to recognize this Content Type</strong></p>
        <p><strong>Toggle automatic extraction (assistant determines what and how to extract)</strong></p>
    </div>
`,
    DeleteContentType: `
<div class="assistantsTooltip">
        <p><h3 style="color:#c45258">Delete the current Content Type</h3></p><br/>
        <p><strong>Delete the currently selected Content Type. Non-reversable</strong></p>
 
    </div>
`,
    ToggleAutoExtractionConf: `
<div class="assistantsTooltip">
    <p><h3 style="color:#2a8091">Toggle Auto Content Extraction</h3></p><br/>
    <p><strong>Let the assistant decide intelligently what content is important and how to structure it.</strong></p>
    <p><strong>Auto Extraction works very well if you don't need persistent data scheme</strong></p>
</div>
`
};

// extraction instructions labels
export const extrConfConfLabels = {
    toggleAutoConfLable: "Assistant Determines What to Extract",
    mutliTextLabel: "Instruct the assistant on how to recognize this content type when it ingests content"
};

// answer length options
export const answerLengthOptions = [
    { key: "1", text: "1" },
    { key: "2", text: "2" },
    { key: "3", text: "3" },
    { key: "4", text: "4" },
    { key: "5", text: "5" },
    { key: "6", text: "6" },
    { key: "7", text: "7" },
    { key: "8", text: "8" },
    { key: "9", text: "9" },
    { key: "10", text: "10" }
];

// inv item order
export const general_item_order = [
    "invoice_date",
    "payment_due_date",
    "contractor_name",
    "contractor_address",
    "contractor_vat_identification",
    "iban",
    "customer_name",
    "customer_address",
    "customer_vat_identification",
    "invoice_total",
    "invoice_total_net",
    "vat",
    "excise",
    "invoice_currency",
    "item_number",
    "description",
    "item_code",
    "item_measure",
    "quantity",
    "unit_price",
    "total_price",
    "invoice_items"
];

// invoice main list divider flags
export const invMainListDividerFlag = new Map<string, string>([
    ["contractor_name", "Contractor Details"],
    ["invoice_date", "Invoice Dates"],
    ["vat", "Invoice Totals"],
    ["item_total", "Totals Validation Recalc."],
    ["invoice_id", "Other Details"],
    ["customer_name", "Customer Details"]
]);


// invoice main list collapsable groups field inclusions
export const invMainFieldToGroupMap = new Map<string, string>([
    ['contractor_name', "Contractor Details"],
    ['contractor_vat_identification', "Contractor Details"],
    ['contractor_address', "Contractor Details"],
    ['iban', "Contractor Details"],
    ['invoice_date', "Invoice Dates"],
    ['payment_due_date', "Invoice Dates"],
    ['vat', "Invoice Totals"],
    ['excise', "Invoice Totals"],
    ['invoice_total', "Invoice Totals"],
    ['invoice_total_net', "Invoice Totals" ],
    ['calculated_invoice_items_total', "Invoice Totals"],
    ['calculated_invoice_items_total', "Totals Validation Recalc."],
    ['invoice_id', "Other Details"],
    ['invoice_currency', "Other Details"],
    ['purchase_order', "Other Details"],
    ['customer_name', "Customer Details"],
    ['customer_address', "Customer Details"],
    ['customer_vat_identification', "Customer Details"]
]);

// invoice main list collapsable groups state
export const collapsableGroupsDefaultState = new Map<string, boolean>([
    ["Contractor Details", false],
    ["Invoice Dates", false],
    ["Invoice Totals", false],
    ["Other Details", false],
    ["Customer Details", false]
]);

// empty conversation recognition object
export const emptyValNumObj = {
    currentValue: "",
    splitValues: [],
    splitLength: 0,
    itemLevel: 0,
    pageNumExtracted: 0
}

// invoice item order
export const invoice_item_order:string[] = [
    "contractor_name",
    "contractor_vat_identification",
    "contractor_address",
    "iban",
    "invoice_date",
    "payment_due_date",
    "vat",
    "excise",
    "invoice_total_net",
    "invoice_total",
    "item_total",
    "calculated_invoice_items_total",
    "grand_total_mismatch",
    "items_with_mismatches",
    "items_with_insufficient_data",
    "insufficient_totals_data",
    "invoice_id",
    "invoice_currency",
    "purchase_order",
    "customer_name",
    "customer_address",
    "customer_vat_identification",
    "invoice_items",
    "item_number",
    "item_code",
    "item_type",
    "description",
    "item_code",
    "quantity",
    "item_measure",
    "unit_price",
    "calculated_total_price",
    "total_price",
    "item_code"
];

// hidden fields ⇒ inv main table (on left of inv)
export const invoice_hidden_fields: string[] = [
    "items_with_mismatches",
    "items_with_insufficient_data",
    "insufficient_pricing_data",
    "total_mismatch",
    "insufficient_totals_data",
    "premain_data",
    "multiple_invoice_suspicion",
    "duplicate_invoice_suspicion",
    "notices",
    "status_message",
    "extraction_success_code",
    "invoice_items",
    "grand_total_mismatch",
    "item_sum_is_gross",
    "validation_usage"
];

// disabled fields ⇒ inv main table (on left of inv)
export const invoice_non_editables: string[] = [
    "grand_total_mismatch",
    "items_with_mismatches",
    "items_with_insufficient_data",
    "insufficient_totals_data",
    "calculated_invoice_items_total",
    "total_mismatch",
    "calculated_total_price",
    "insufficient_pricing_data",
    "item_total"
];

// invoice main table tooltips
export const inv_main_tbl_tooltips: Record<string, string> = {
    calculated_invoice_items_total: "Recalculated total of all line items based on recognized data.",
    item_total: "Result of recalculating the NET total from the recognized data."
};

//  toast base options
export const toastBaseOpt: ToastOptions = {
    autoClose: false,
    closeOnClick: true,
    closeButton: true
};



// apply replacements function
export const applyReplacements = (input: string) => {
    let result = input;
    for (const { text, replacement } of pb_replace) {
        const regex = new RegExp(text, "g"); // global replace
        result = result.replace(regex, replacement);
    }
    return result;
}

// main invoice field renames
export const invoice_key_renames = (key: string) => {
    // calculated_invoice_items_total - total of our ai recalc of the invoice - GROSS VAL, item_total - total of the invoice items as they are in the invoice - NET VAL
    let key_rename =
        key == "calculated_invoice_items_total"
            ? "Total Recalc."
            : key == "customer_vat_identification"
            ? "Customer VAT"
            : key == "item_total"
            ? "NET Total Recalc."
            : key == "customer_vat_identification"
            ? "Customer VAT"
            : key == "contractor_vat_identification"
            ? "Contractor VAT"
            : key;
    return key_rename;
};

// empty convo recog object
export const emptyConvoRecognizedObject = () => {
    return {
        final_upstream_msg: "",
        should_run_oai: false,
        conjoined_obj: {
            conjoined_msg: "",
            conjoined_segments: ""
        },
        conj_clean: "",
        value_valid_bot_not_in_data: "",
        additional_instructions: "",
        msg_ovrride: ""
    };
};

// pb exclusion strings
export const pb_excl: string[] = [
    "internal use",
    "p a g e",
    "page",
    "internaluse",
    "confidential",
    "Confidential"
];

// cca convo replacements
export const conv_collect_replacements = {
    "€": "e",
    "сaвa ": "св ",
    "сaв ": "св ",
    "съвъ ": "св ",
    "съв ": "св "
};

// email input validation
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const getEmptyRecog = () =>
{
    return { segments: [], recognized: [] }
}

export const tipsInvMap: Map<string, string> = new Map<string, string>([
    ["validation_source", `<div>Content from the Assistant knowledge or an external system, that's used to ground values or inform decisions</div><div>For prefiltering & direct matching, the source column should match the id of this column</div>`],
    ["item_client_code", "Client code - code used by your company to identify this item"]
]);

export const predefinedProcessOptions = [
    { key: "none", text: "None" },
    { key: "reconcile", text: "Reconcile" },
    { key: "verify", text: "Verify" },
    { key: "prefilter", text: "Prefilter" },
    { key: "ground", text: "Ground" },
    { key: "validate", text: "Validate" },
];

export const filterPriorityOptions = [
    { key: "0", text: "0 - Runs 1st" },
    { key: "1", text: "1" },
    { key: "2", text: "2" },
    { key: "3", text: "3" },
    { key: "4", text: "4" },
    { key: "5", text: "5 - Default" },
    { key: "6", text: "6" },
    { key: "7", text: "7" },
    { key: "8", text: "8" },
    { key: "9", text: "9" },
    { key: "10", text: "10 - Last Filter Operation" }
];






export const convConfToolStrUnvoice = "Enable a complete voice assistant experience. NOTE: This assistant is not a native voice assistant - enabling voice conversations for non-voice assistants requires licensing. For a demo of voice, create a voice assistant (Call Center Assistant) or contact us.";

export const convConfToolStrNative = "Enable natural voice conversations, scenario-based interactions, data collections, trainings in a true intelligent ai conversational experience.";


export const invPrefCurrencyOptions: IDropdownOption[] = [
    { key: "NONE", text: "No Preference" },
    { key: "EUR", text: "EUR - Euro" },
    { key: "LEV", text: "LEV - Bulgarian Lev" },
    { key: "USD", text: "USD - US Dollar" },
    { key: "GBP", text: "GBP - British Pound" },
    { key: "CAD", text: "CAD - Canadian Dollar" },
    { key: "AUD", text: "AUD - Australian Dollar" },
    { key: "CHF", text: "CHF - Swiss Franc" },
    { key: "PLN", text: "PLN - Polish Zloty" },
    { key: "RSD", text: "RSD - Serbian Dinar" },
    { key: "RON", text: "RON - Romanian Leu" },
    { key: "JPY", text: "JPY - Japanese Yen" },
];


export const reportingPeriodsDropdownOptions: IDropdownOption[] = [
    { key: 'thisWeek', text: 'This Week' },
    { key: 'lastWeek', text: 'Last Week' },
    { key: 'last7Days', text: 'Last 7 Days' },
    { key: 'currentMonth', text: 'This Month' },
    { key: 'lastMonth', text: 'Last Month' },
    { key: 'last30Days', text: 'Last 30 Days' }
]